import { AddCardOutlined, Filter } from '@mui/icons-material'
import { Button, CircularProgress, IconButton, Tooltip } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import "../../styles/Category.css"
import { Input } from 'antd'
import DeleteIcon from '@mui/icons-material/Delete';
import TextArea from 'antd/es/input/TextArea'
import CloseIcon from '@mui/icons-material/Close';

export default function ShopCategories({propsData}) {
  const location = useLocation()
    const [routes,setRoutes]=useState(location.pathname.split("/"))
    let [categories,GetCategories]=useState([])
    useEffect(()=>{
            axios.get(`${process.env.REACT_APP_URL}/api/category/GetAllCategories/${routes[2]}`, //proxy uri
            {
               headers: {
                  authorization:`Bearer ${ propsData.userData?.token }`,
                  'Content-Type': 'application/json'
               } 
            })
            .then(res=>{
            console.log(res.data);
              GetCategories(res.data)
            })
            .catch(error=>{
              console.log(error);
            })
      },[propsData.equilizer])

    let [seeAddPage,handleSeePage]=useState(false)
    let [requiredKeys,handleRequiredKeys]=useState([
                      { type:"default",
                        value:"name",
                        isChanging:false,
                         id:crypto.randomUUID()
                      },
                        {type:"default",
                        value:"price",
                        isChanging:false,
                        id:crypto.randomUUID()
                      }, 
                        {type:"default",
                        value:"description",
                        isChanging:false,
                        id:crypto.randomUUID()
                      },
                        {type:"default",
                        value:"images",
                        isChanging:false,
                        id:crypto.randomUUID()
                      }
                  ])
const AddInput = () => {
  let data = {
    type: "manageble",
    value: "",
    isChanging:false,
    id:crypto.randomUUID(),
  };
  handleRequiredKeys((prevState) => [...prevState, data]);
};
 
  let filterNull=requiredKeys.filter(e=>{
    return e.value===""
  })

  //console.log(requiredKeys,filterNull);
  const ClosePage=()=>{
    handleRequiredKeys([
      { type:"default",
        value:"name",
        isChanging:false,
         id:crypto.randomUUID()
      },
        {type:"default",
        value:"price",
        isChanging:false,
        id:crypto.randomUUID()
      }, 
        {type:"default",
        value:"description",
        isChanging:false,
        id:crypto.randomUUID()
      },
        {type:"default",
        value:"images",
        isChanging:false,
        id:crypto.randomUUID()
      }
    ])
    handleSeePage(false)
  }

  let[loading,setLoading]=useState(false)
  let[error,setError]=useState(false)
  let [name,setName]=useState("")

  const saveChanges=()=>{
    setLoading(true)
   // console.log(requiredKeys.slice(4,));
    let data={
      name:name,
      requiredKeys:requiredKeys.slice(4,),
      shop:routes[2]
    }
    
    axios.post(`${process.env.REACT_APP_URL}/api/category/AddNewCategories`, data,//proxy uri
    {
       headers: {
          authorization:`Bearer ${ propsData.userData?.token }`,
          'Content-Type': 'application/json'
       } 
    })
    .then(res=>{
      console.log(res.data);
      handleRequiredKeys([
        { type:"default",
          value:"name",
          isChanging:false,
           id:crypto.randomUUID()
        },
          {type:"default",
          value:"price",
          isChanging:false,
          id:crypto.randomUUID()
        }, 
          {type:"default",
          value:"description",
          isChanging:false,
          id:crypto.randomUUID()
        },
          {type:"default",
          value:"images",
          isChanging:false,
          id:crypto.randomUUID()
        }
      ])
      handleSeePage(false)
      setLoading(false)
      propsData.setEquilizer(propsData.equilizer+2)
    })
    .catch(error=>{
      console.log(error);
      setLoading(false)
      setName("")
      setError(error?.response?.data?.error||"Error occured, Try again later")
      setTimeout(()=>{
        setError("")
      },5000)
    })

  }

  return (
    <>
      <div className='each-shop-categories'> 
          <div>
              <Tooltip   title="Create">
                  <IconButton onClick={()=>handleSeePage(!seeAddPage)}><AddCardOutlined style={{ color:"rgb(170, 141, 12)"}}/></IconButton>

              </Tooltip>
            </div>
          <div className='each-shop-categories-all'>
              {categories.map(e=>{
                  return <EachCategories  key={e._id} item={e}/>
              })}
              {categories.length===0&&
                <div>
                   No Category is found !
                </div>
              }
          </div>
          
      </div>
      {seeAddPage&&
         <div className='each-shop-categories-create'>
            <div  className='each-shop-categories-create-box'>
              <div><IconButton onClick={ClosePage}><CloseIcon style={{color:"red"}}/></IconButton></div>
              <h3>Create Category</h3>
              <div className='each-shop-categories-create-box-name'>
                  <div>Category name</div>
                  <div> <Input placeholder='name' value={name} onChange={(e)=>setName(e.target.value.toLowerCase())}/></div>
               </div>
              <h4>Add Required keys</h4>
              <div className='each-shop-categories-create-intro'>
                    <p>Required keys are the essential fields that every admin must fill out when creating material in this category.</p>
                    <p><b>Note:</b> Please exercise caution when adding categories, as they cannot be edited in the future without permission from the owner. By default, four keys are provided, and you have the ability to add additional keys as needed.</p>
              </div>
              <div className='each-shop-categories-createe-keys'>
                    {requiredKeys.map((e,index)=>{
                      return <EachKeys  key={e.id} requiredKeys={requiredKeys} handleRequiredKeys={handleRequiredKeys} item={e} />
                    })}

                    {error&&<div style={{textAlign:"center",color:"red",marginTop:"30px"}}>{error}</div>}

                   {loading?
                     <CircularProgress style={{marginTop:"30px"}} size={20}/>
                     :
                  <div  className='each-shop-categories-createe-keys-addButton'>
                      <div className='each-shop-categories-createe-keys-add'><Button disabled={filterNull.length>0} onClick={AddInput}>Add</Button></div>
                       <div className='each-shop-categories-createe-keys-save'><Button disabled={filterNull.length>0||name.length<1||requiredKeys.length<=4}  onClick={saveChanges}>Save</Button></div>
                  </div>}  
                </div> 

            </div>
         </div>}
    </>
  )
}

const EachKeys=({item,handleRequiredKeys,requiredKeys})=>{

  let [value,setValue]=useState(item.value)

  const AddDone = (id) => {

    handleRequiredKeys((e) =>
      e.map((el) => {
          return id===el.id?{ ...el, value:value,isChanging:false }:{...el};
     
      })
    );
  };
   
const onChange=(e)=>{
  setValue(e.target.value.toLowerCase())
  handleRequiredKeys((e) =>
      e.map((el) => {
          return item.id===el.id?{ ...el,isChanging:true }:{...el};
      })
    );
}

const handleKeyDown = (event) => {
  if (event.key === 'Enter') {
    event.preventDefault(); // Prevent the default behavior of newline insertion
    AddDone(item.id)
  }
};


const RemoveKey = () => {
  handleRequiredKeys((e) => {
    const updatedKeys = e.filter((el) => el.id !== item.id);
    return updatedKeys;
  });
};

  return(
    <div className='each-shop-categories-createe-keys-each'>
        <div className='each-shop-categories-createe-keys-each-input'>
           <Input 
              disabled={item.type==="default"}
              placeholder='Key'
              onKeyDown={handleKeyDown}
              value={value} onChange={onChange}/>
         </div>
        <div className='each-shop-categories-createe-keys-each-button'>
            {(item.value===""||item.isChanging)?<Button onClick={()=>AddDone(item.id)}>Done</Button>:<IconButton onClick={RemoveKey}  disabled={item.type==="default"}><DeleteIcon style={{color:"red"}}/></IconButton>}

        </div>
    </div>
  )
}


const EachCategories=({item})=>{

  return(
    <NavLink to={`/categories/${item._id}`}>
      <div className='each-shop-categories-each'>
          <div className='each-shop-categories-each-name'>{item.name}</div>
          <div className='each-shop-categories-each-by'>By {item?.createdBy?.username}</div>
      </div>

    </NavLink>
  )
}